import { useSelector } from 'react-redux'
import { operationSlice } from '../app/reducers/operation'
import { getCurrencySymbolSafe, formatAmountPart } from '../helpers/currency'

export default function PaymentResultAmount(){
  const operation = useSelector(operationSlice.selectSlice);

  const amount = operation && operation.operation ? operation.operation.payment_details.amount : null;
  const currency = operation && operation.operation ? operation.operation.payment_details.currency : null;
  const symbol = getCurrencySymbolSafe(currency);

  return (
    <div className={"payment-result-amount"}>
      <span className={"currency"}>{symbol}</span>
      <span className={"integer-part"}>{formatAmountPart(amount, 2, "integer")}</span>
      <span className={"decimal-part"}>.{formatAmountPart(amount, 2, "decimal")}</span>
    </div>
  );
}
